<template>
	<div class="main">
		<div class="modal fade in show" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<span class="modal-title">新增費用設定</span>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePopup">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label for="year" class="col-sm-4 col-xs-2 column-required">學年度</label>
								<div class="col-sm-8 col-xs-10">
									<input id="year" name="year" v-model="form.year" v-validate="'required'" type="text" class="form-control" maxlength="3"/>
									<span class="text-danger" v-show="errors.has('year')">{{ errors.first('year') }}</span>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="applyType" class="col-sm-4 col-xs-2 column-required">申請等級</label>
								<div class="col-sm-8 col-xs-10">
									<input id="applyType" name="applyType" v-model="form.applyType" v-validate="'required'" type="text" class="form-control" maxlength="64"/>
									<span class="text-danger" v-show="errors.has('applyType')">{{ errors.first('applyType') }}</span>
								</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-4 form-group">
								<label for="applyDesc" class="col-sm-4 col-xs-2">申請說明</label>
								<div class="col-sm-8 col-xs-10">
									<input id="applyDesc" name="applyDesc" v-model="form.applyDesc" type="text" class="form-control" maxlength="64"/>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="amount" class="col-sm-4 col-xs-2">補助金額</label>
								<div class="col-sm-8 col-xs-10">
									<input id="amount" name="amount" v-model="form.amount" type="number" class="form-control" min="0"/>
								</div>
							</div>
							<div class="col-md-4 form-group">
								<label for="schAmount" class="col-sm-4 col-xs-2">學校支付額</label>
								<div class="col-sm-8 col-xs-10">
									<input id="schAmount" name="schAmount" v-model="form.schAmount" type="number" class="form-control" min="0"/>
								</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-8 form-group">
								<label for="comment" class="col-sm-2 col-xs-1">備註</label>
								<div class="col-sm-10 col-xs-11">
									<textarea id="comment" name="comment" v-model="form.comment" class="form-control" rows="4" />
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" @click="handleSave">{{this.id == "" ? '新增' : '儲存'}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: [ 'id'],
	data(){
		return {
			form: {
				year: "",
				applyType: "",
				applyDesc: "",
				amount: "",
				schAmount: "",
				comment: ""
			}
		}
	},
	mounted(){
		this.pageInit();
	},
	methods:{
		pageInit(){
			if(this.id != "") {
				const api = `/api/weakFee/${this.id}`;
				this.$axios.get(api).then(resp => {
					if (resp.data.status === "success") {
						this.form = resp.data.data
					} else {
						bootbox.alert(resp.data.msg);
					}
				})
			}
		},
		handleSave() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					if(this.id == "") {
						// 新增
						const api = "/api/weakFee";
						this.$axios.post(api, this.form).then(resp => {
							if (resp.data.status === "success") {
								bootbox.alert("新增成功");
								this.closePopup();
							} else {
								bootbox.alert(resp.data.msg);
							}
						});
					} else {
						// 修改
						const api = `/api/weakFee/${this.id}`;
						this.$axios.post(api, this.form).then(resp => {
							if (resp.data.status === "success") {
								bootbox.alert("儲存成功");
								this.closePopup();
							} else {
								bootbox.alert(resp.data.msg);
							}
						});
					}
				} else {
					bootbox.alert("請確認必填欄位是否有填寫")
				}
			});
		},
		closePopup() {
			this.$parent.showEditPopup(false);
		}
	}
}
</script>
<style scoped>
@media (min-width: 768px){
	.modal-dialog {
		width: 720px;
		margin: 30px auto;
	}
}

@media (min-width: 992px){
	.modal-dialog {
		width: 880px;
		margin: 30px auto;
	}
}

@media (min-width: 1200px){
	.modal-dialog {
		width: 1120px;
		margin: 30px auto;
	}
}
</style>
